import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { IconProps } from "../Facebook/FacebookIcon";

const TIKTOK_BRAND = "#fe2c55";

export const TiktokIcon = (props: IconProps) => {
  const { active, className, size = "1x", color } = props;

  return (
    <FontAwesomeIcon
      style={{
        color: color || (active ? TIKTOK_BRAND : "gray"),
      }}
      icon={["fab", "tiktok"]}
      className={className}
      size={size}
    />
  );
};
